<template>
    <select v-model="modelValue">
        <option value="" selected>{{ placeholder }}</option>
        <option v-for="option in options" :key="option.value" :value="option.value">
            <slot name="option" :option="option">
                {{ `${option.value} - ${option.text}` }}
            </slot>
        </option>
    </select>
</template>

<script lang="ts" setup>
import { defineProps, defineModel, PropType } from 'vue';

interface Option {
    value: string;
    text: string;
}

const props = defineProps({
    options: {
        type: Array as PropType<Option[]>,
        default: () => []
    },
    placeholder: {
        type: String,
        required: false,
        default: ''
    }
});

const modelValue = defineModel<string>();
</script>

<style scoped>

</style>
